import { z } from 'zod';
import { appManifestSchema } from '@xiltrion/identidad';
export const AppStatus = { ACTIVE: 'ACTIVE', DISABLED: 'DISABLED' };
export const appRegisterSchema = appManifestSchema.extend({
    /** Vacío: la consola genera uno. */
    oidcClientId: z.string().trim().min(1).optional(),
    sort: z.number().int().default(100),
});
export const appUpdateSchema = appRegisterSchema.partial().extend({ status: z.enum(['ACTIVE', 'DISABLED']).optional() }).omit({ code: true });
/** Apps con logo oficial en el portal de la suite (`apps/web/public/logos/<code>.svg`, generado con `pnpm logos`). */
export const APPS_WITH_LOGO = ['erp', 'sgdea', 'planning'];
/** Ruta del logo oficial en el portal (`/logos/planning.svg`); `null` si la app no tiene y se dibuja con ícono y color. */
export const appLogoPath = (code) => APPS_WITH_LOGO.includes(code) ? `/logos/${code}.svg` : null;
//# sourceMappingURL=apps.js.map